// extracted by extract-css-chunks-webpack-plugin
module.exports = {"continueBtn":"enable-group-gift-modal__continueBtn__28Fjz"};